import { Injectable } from '@angular/core';
import { UrlProviderService } from './local/url-provider.service';
import { HttpinterceptorService } from './httpinterceptor';
import { CheckCustomerByNviRequestModel } from '../models/RequestPayloads/CheckCustomerByNviRequestModel';
import { CheckIdentityNumberResponse } from '../models/Response/CheckIdentityNumberResponse';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

constructor(private urlProvider:UrlProviderService, private http:HttpinterceptorService) { }

  public checkCustomerByIdentifier(identifier:string):Promise<boolean>{
    var url = this.urlProvider.checkCustomerByIdentifier(identifier);
    return this.http.getRequest(url, true).toPromise().then((res:boolean) => res)
  }

  public checkCustomerByNviService(requestPayload:CheckCustomerByNviRequestModel):Promise<CheckIdentityNumberResponse>{
    var url = this.urlProvider.getCheckCustomerByNviServiceURL();
    return this.http.postRequest(url, requestPayload, true).toPromise().then((res:CheckIdentityNumberResponse) => res)
  }

}
